/** Server CSV cross-source exclude: internal reset vs parent-controlled (phone aggregate parity). */
import { useEffect } from 'react';

import { useCsvExportModalCrossSourceExclude } from './useCsvExportModalCrossSourceExclude';

type CrossSourceStateParams = {
  open: boolean;
  exportColumnKeys: string[];
  serverCsvExport: unknown;
  controlledExcludeCrossSourceNotedRows?: boolean;
  onControlledExcludeCrossSourceNotedRowsChange?: (value: boolean) => void;
};

export function useCsvExportModalCrossSourceState(
  params: CrossSourceStateParams,
): readonly [boolean, (v: boolean) => void] {
  const isControlled =
    Boolean(params.serverCsvExport) &&
    typeof params.controlledExcludeCrossSourceNotedRows === 'boolean' &&
    typeof params.onControlledExcludeCrossSourceNotedRowsChange === 'function';

  const [internalExclude, setInternalExclude] = useCsvExportModalCrossSourceExclude(
    isControlled ? false : params.open,
    params.exportColumnKeys,
  );

  const onControlledChange = params.onControlledExcludeCrossSourceNotedRowsChange;

  useEffect(() => {
    if (!isControlled || !onControlledChange) return;
    if (!params.exportColumnKeys.includes('crossSourceFilterNote')) {
      onControlledChange(false);
    }
  }, [isControlled, onControlledChange, params.exportColumnKeys]);

  if (
    isControlled &&
    typeof params.controlledExcludeCrossSourceNotedRows === 'boolean' &&
    onControlledChange
  ) {
    return [params.controlledExcludeCrossSourceNotedRows, onControlledChange] as const;
  }
  return [internalExclude, setInternalExclude] as const;
}
